import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferSpotifyToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferSpotifyToAppleMusic}
            sections={<PairTransferGuideContent sourceKey="spotify" destKey="appleMusic" />}
        />
    );
}
